export const repertoireId = '1X4ogRpGiCeG6tQaliwYvooiXCxsB8ihzV7ii1GIOSJk'

export const testimonialId = '1r0xjnfxqUCwq2keSaIfcEjkQKN43nfKR-3dZwOjHCH0'

export const baseSheetUrl = id =>
  `https://sheets.googleapis.com/v4/spreadsheets/${id}/values/sheet1!A2:B200?alt=json&key=${process.env.REACT_APP_API_KEY}`

export const formUrl = `/`
